export const API_URL = 'https://alradwan-mirror-api.octopharma.net/api'
// export const API_URL = 'https://api.alradwan.octopharma.net/api'
export const VERSION = '2.7.5'
